export default __webpack_public_path__ + "static/media/expense-outline-16px.d24ca640.svg";